// extracted by mini-css-extract-plugin
export default {"tableFixHeadFoot":"AuditTrail_tableFixHeadFoot__lfNIS","tableCellAlignCenter":"AuditTrail_tableCellAlignCenter__+I4fI","footerAlignCenter":"AuditTrail_footerAlignCenter__+Ris7"};